import { Select, Tag } from "antd";
import React from "react";
import { option } from "../../Common/types";
import type { CustomTagProps, DisplayValueType } from "rc-select/lib/BaseSelect";

// must add all classes here
import "./Dropdown.less";

interface Props {
  options: option[];
  mainClassName: string;
  value: string | string[];
  multiSelect?: "multiple" | "tags";
  menuItemSelectedIcon?: React.ReactElement;
  maxTagCount?: number;
  isLoading?: boolean;
  isDisabled?: boolean;
  onChange?: (value: string | string[]) => void;
  title?: string;
  isShowArrow?: boolean;
  isShowSearch?: boolean;
  notFoundContent?: null;
}

const { Option } = Select;

const Dropdown: React.FC<Props> = (props) => {
  const {
    options,
    mainClassName,
    value,
    isLoading,
    onChange,
    title,
    notFoundContent,
    maxTagCount = 1,
    menuItemSelectedIcon,
    multiSelect = undefined,
    isShowArrow = true,
    isShowSearch = false,
    isDisabled = false,
  } = props;

  const tagRender = (props: CustomTagProps) => {
    return (
      <Tag color={"transparent"} closable={false}>
        {`${props.label} `}
      </Tag>
    );
  };
  const maxTagPlaceholder = (omittedValues: DisplayValueType[]) => {
    return (
      <Tag color={"transparent"} closable={false}>
        {omittedValues.map((e) => "," + e.label)}
      </Tag>
    );
  };
  return (
    <div className={mainClassName}>
      {title ? <div className={"primary-title"}>{title}</div> : <></>}
      <Select
        loading={isLoading}
        disabled={isDisabled}
        showArrow={isShowArrow}
        showSearch={isShowSearch}
        mode={multiSelect}
        maxTagCount={maxTagCount}
        menuItemSelectedIcon={menuItemSelectedIcon}
        maxTagPlaceholder={maxTagPlaceholder}
        tagRender={tagRender}
        value={value}
        onChange={onChange}
        notFoundContent={notFoundContent}
        listHeight={200}
      >
        {options.map(({ value, label }, index) => (
          <Option key={index} value={value}>
            {label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default Dropdown;
